import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import PaymentLinkStars from '../PaymentLinkStars/PaymentLinkStars';

export const FOOTER_DATE = 'April 15th, 2025';

interface PaymentLinkFooterProps {
  name?: string;
  showMoneyGoesBox?: boolean;
  footerTextComponent?: React.ReactNode;
  footerRightComponent?: React.ReactNode;
  isQR?: boolean;
  customBackgroundColorContainer?: string;
  customBackgroundColorIcon?: string;
}

const PaymentLinkFooter = ({
  name,
  showMoneyGoesBox,
  footerTextComponent,
  footerRightComponent,
  isQR,
  customBackgroundColorContainer,
  customBackgroundColorIcon,
}: PaymentLinkFooterProps) => {
  const {t} = useTranslation();

  return (
    <>
      {showMoneyGoesBox && name && (
        <Box
          className={`payment-link-money-goes-container${isQR ? ' payment-link-money-goes-qr-container' : ''}`}
          sx={{
            ...(customBackgroundColorContainer && {
              backgroundColor: `${customBackgroundColorContainer} !important`,
            }),
          }}>
          <Typography className="payment-link-money-goes-text">
            {t('payment_link.footer_box_text', {name})}
          </Typography>
          <Box
            className="payment-link-money-goes-text-icon-container"
            sx={{
              ...(customBackgroundColorIcon && {
                backgroundColor: `${customBackgroundColorIcon} !important`,
              }),
            }}>
            <GppGoodOutlinedIcon className="payment-link-money-goes-icon" />
            <Box className="payment-link-money-goes-arrow-icon-container">
              <Box
                component="img"
                src="/assets/icons/arrow_upward.svg"
                alt="arrow"
              />
            </Box>
          </Box>
        </Box>
      )}
      <Box className="payment-link-footer-container">
        <Box className="payment-link-footer-security-container">
          <PaymentLinkStars />
          <Box
            component="img"
            src="/assets/icons/vertical_divider.svg"
            alt="vertical divider"
          />
          {footerRightComponent ? (
            footerRightComponent
          ) : (
            <Box className="security-image-container">
              <Box
                component="img"
                src="/assets/icons/secure-encrypt.svg"
                alt="secure encryption"
                sx={{
                  width: 29,
                  height: 29,
                }}
              />
              <Box className="security-labels-container">
                <Typography className="security-title">
                  {t('payment_link.secure')}
                </Typography>
                <Typography className="security-subtitle">
                  {t('payment_link.tls_encryption')}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        <Box className="payment-link-footer-text-container">
          {footerTextComponent ? (
            footerTextComponent
          ) : (
            <>
              <Typography className="payment-link-footer-text payment-link-footer-text-first">
                {t('payment_link.first_label_footer', {date: FOOTER_DATE})}
              </Typography>
              <Typography className="payment-link-footer-text">
                {t('payment_link.second_label_footer')}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default PaymentLinkFooter;
